const state = {
  id: null,
  font_family_id: undefined,
  match_title: '',
  title: '',
}

export const requiredFields = [
  { key: 'font_family_id' },
  { key: 'match_title' },
  { key: 'title' },
]

export default state
